var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFarmer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 508.528 508.528",
    style: {
      enableBackground: "new 0 0 508.528 508.528"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF7C45"
    },
    d: "M87.728,300.528c-0.024,0-0.088,4.64-0.088,6.192c0.008,75.48,26.512,145.808,67.424,185.808h199.032 c40.92-40,67.44-110.328,67.44-185.808c0-1.552-0.064-6.192-0.088-6.192L87.728,300.528L87.728,300.528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC2A0"
    },
    d: "M87.728,300.528c-0.024,0-0.088,3.968-0.088,5.512c0,9,0.4,18.312,1.136,27.04 c13.896,10.184,82.752,18.184,165.808,18.184s151.928-7.672,165.808-17.856c0.736-8.728,1.144-18.416,1.144-27.416 c0-1.552-0.064-5.472-0.088-5.472H87.728V300.528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE9D7C"
    },
    d: "M254.592,351.488c83.056,0,151.928-7.784,165.808-17.968c0.736-8.728,1.144-18.48,1.144-27.48 c0-1.544-0.064-5.512-0.088-5.512H87.728c-0.024,0-0.088,3.968-0.088,5.512"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#684525"
    },
    d: "M423.112,303.144c0,11.992-75.456,21.736-168.52,21.736S86.08,315.136,86.08,303.144 c0-12.032,75.456-21.76,168.512-21.76C347.656,281.384,423.112,291.112,423.112,303.144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F291A"
    },
    d: "M423.112,303.144c0,11.992-75.456,21.736-168.52,21.736S86.08,315.136,86.08,303.144 c0-12.032,71.192-2.872,164.256-2.872S423.112,291.112,423.112,303.144z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 281.192,
    cy: 214.608,
    rx: 54.176,
    ry: 44.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 227.944,
    cy: 214.608,
    rx: 54.176,
    ry: 44.4
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA9678"
    },
    points: "455.088,369.696 302.552,322.576 302.552,308.528 206.552,308.528 206.552,322.576  54.008,369.696 61.48,500.528 61.48,500.528 62.552,500.528 446.552,500.528 448.28,500.528 448.28,500.528 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A57E59"
    },
    points: "455.088,369.696 302.552,322.576 302.552,308.528 206.552,308.528 206.552,322.576  54.008,369.696 124.168,500.528 124.168,500.528 63.688,500.528 446.552,500.528 448.28,500.528 448.28,500.528 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#936A41"
    },
    points: "262.552,500.528 63.688,500.528 446.552,500.528 448.28,500.528 448.28,500.528  455.84,369.696 302.552,322.576 302.552,308.528 206.552,308.528 206.552,322.576 52.688,368.776 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042635"
    },
    d: "M358.976,169.224c0,35.264-51.152,15.968-104.432,15.968c-53.248,0-104.416,19.296-104.416-15.968 c0-35.256,51.168-63.848,104.416-63.848C307.824,105.368,358.976,133.968,358.976,169.224z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 206.552,
    y: 220.528,
    style: {
      fill: "#F9BDA0"
    },
    width: 96,
    height: 112
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9BDA0"
    },
    points: "303.928,338.784 254.552,482.784 205.168,338.784 255.096,262.872  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAA78C"
    },
    points: "302.552,315.576 302.552,220.528 207.64,220.528 255.816,435.504 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCCCB9"
    },
    d: "M329.344,137.96c0,72.072-36.544,137.296-74.776,137.296s-74.792-65.224-74.792-137.296 c0-72.08,36.552-84.104,74.792-84.104C292.8,53.856,329.344,65.88,329.344,137.96z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BDA0"
    },
    d: "M254.568,53.856c38.232,0,74.776,12.024,74.776,84.104c0,72.072-36.544,137.296-74.776,137.296"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.466,
    y: 113.702,
    transform: "matrix(-0.8775 -0.4796 0.4796 -0.8775 401.7262 406.8471)",
    style: {
      fill: "#F9BDA0"
    },
    width: 120.721,
    height: 76.825
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042635"
    },
    d: "M264.96,49.112c0,0-69.504,53.2,89.72,117.296c0,0,3.048-70.52-22.952-101.264 c-26.016-30.72-66.28-26.936-66.28-26.936L264.96,49.112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042635"
    },
    d: "M289.856,40.024c0,0,64.008,70.952-135.36,131.744c0,0-11.752-75.792,18.944-108.272 c30.688-32.488,85.72-27.088,85.72-27.088L289.856,40.024z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA9678"
    },
    points: "254.552,482.784 280.424,404.528 227.72,404.528 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A37F64"
    },
    points: "254.552,482.784 281.384,404.528 249.008,404.528 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A37C58"
    },
    points: "431.48,126.72 254.52,0.856 76.456,126.92 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#936A41"
    },
    points: "433.064,126.72 254.52,0.856 140.088,126.92 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DB976A"
    },
    points: "395.864,100.528 254.52,0 113.496,100.528 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BF7C45"
    },
    points: "395.864,100.528 254.52,0 151.56,100.528 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#936A41"
    },
    points: "225.72,20.528 283.384,20.528 272.136,12.528 236.944,12.528  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#936A41"
    },
    points: "192.056,44.528 317.128,44.528 305.704,36.528 203.272,36.528  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#936A41"
    },
    points: "158.264,68.528 350.992,68.528 339.624,60.528 169.608,60.528  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#936A41"
    },
    points: "124.72,92.528 384.616,92.528 373.368,84.528 135.936,84.528  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#684525"
    },
    d: "M126.552,499.728c0,2.472-1.52,4.472-4,4.472l0,0c-2.48,0-4-2-4-4.472V343.88 c0-2.48,1.52-4.48,4-4.48l0,0c2.48,0,4,2,4,4.48V499.728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#684525"
    },
    d: "M390.552,504.056c0,2.472-1.792,4.472-4,4.472l0,0c-2.208,0-4-2-4-4.472V345 c0-2.472,1.792-4.472,4-4.472l0,0c2.208,0,4,2,4,4.472V504.056z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmer);
export default __webpack_public_path__ + "static/media/farmer.c6da7574f65c3dc1e8af01310e34fd86.svg";
export { ForwardRef as ReactComponent };